import { Trans } from '@lingui/macro';
import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import AuthLayout from '@/UI/auth-layout';
import PutDevicePassword from '@/components/DevicePassword/devicePassword-sections/PutDevicePassword/PutDevicePassword';
import { useAppSelector } from '@/hooks/useRedux';
import { ROOT_PATH } from '@/routes/router.types';
import { privateKeyArray } from '@/store/server-data-reducer/selectors-server-data';

const DevicePasswordPage: FC = () => {
    const isPrivateKeyAvailable = useAppSelector(state =>
        privateKeyArray(state),
    );
    if (isPrivateKeyAvailable.length <= 0) {
        return <Navigate to={ROOT_PATH.login} />;
    }

    return (
        <AuthLayout
            header={<Trans>Device Key Password</Trans>}
            subHeader={<>Enter your device key password</>}>
            <PutDevicePassword />
        </AuthLayout>
    );
};

export default DevicePasswordPage;
